import domReady from '@wordpress/dom-ready';

/** Internal Dependencies */
import { ControllerComponent } from './ControllerComponent';

export default class MobileMenu extends ControllerComponent {
  constructor() {
    super();

    this.reset = this.reset.bind( this );
  }

  reset () {
    this.setState( {
      menuActive: false,
      activeItem: null,
    } );
  }

  init () {
    domReady( function () {
      const menuParentItems = document.querySelectorAll( '#mobile-nav .menu-parent' ); // Select only top-level items
      const menuParentItemLabels = document.querySelectorAll( '#mobile-nav .menu-parent span' );
      const buttons = document.querySelectorAll( '#mobile-nav .menu-item-has-children button' );


      const menuItems = document.querySelectorAll( '.menu-item-has-children' );

      menuItems.forEach( ( menuItem ) => {
        const button = menuItem.querySelector( 'button' );
        const submenu = menuItem.querySelector( '.sub-menu' );

        // Update aria-expanded and aria-expanded for items with the 'open' class
        if ( menuItem.classList.contains( 'open' ) ) {
            button?.setAttribute( 'aria-expanded', 'true' );
            submenu?.setAttribute( 'aria-expanded', 'true' );
        } else {
            button?.setAttribute( 'aria-expanded', 'false' );
            submenu?.setAttribute( 'aria-expanded', 'false' );
        }
      } );


      const toggleMenuItem = ( parent ) => {
        const submenu = parent.querySelector( '.sub-menu' );
        const button = parent.querySelector( 'button' );
        const isOpen = parent.classList.contains( 'open' );

        // Close all other top-level menu items that are not ancestors of the current item
        menuParentItems.forEach( ( item ) => {
          if ( item !== parent && !item.contains( parent ) ) {
            item.classList.remove( 'open' );
            item.querySelector( 'button' )?.setAttribute( 'aria-expanded', 'false' );
            item.querySelector( '.sub-menu' )?.setAttribute( 'aria-expanded', 'false' );
          }
        } );

        // Toggle the clicked item
        parent.classList.toggle( 'open', !isOpen );
        button?.setAttribute( 'aria-expanded', !isOpen );
        submenu?.setAttribute( 'aria-expanded', !isOpen );
      };


      [ ...menuParentItemLabels, ...buttons ].forEach( ( element ) => {
        element.addEventListener( 'click', ( e ) => {
          const parent = e.target.closest( '.menu-item-has-children' );
          if ( parent ) toggleMenuItem( parent );
        } );
      } );
    } );
  }
}
